import React from 'react';
import {Route, Switch, useLocation} from 'react-router-dom';
import {useSelector} from 'react-redux';
import {parse} from 'query-string';
import moment from 'moment-timezone';

import '../../theme';

import authenticationService from '../services/authentication/AuthenticationService';
import documentService from '../services/document/DocumentService';
import {openOrSaveFile} from '../utils/http';
import {mountFAQ, unmountFAQ} from '../utils/tbFAQ';
import OrganisationGate from '../gates/OrganisationGate';
import OrganisationRegisterView from '../views/organisationRegister/OrganisationRegisterView';
import OrganisationRegisterPlan from '../views/organisationRegister/registerPlan';
import {OrganisationRegisterHelpView} from '../views/organisationRegister/OrganisationRegisterHelpView';
import GlobalDashboard from '../components/globalDashboard';
import GlobalSubcontractors from '../components/globalSubcontractors';
import UserSettings from '../components/userSettings';
import Header from '../components/header';

import ErrorBoundary from './ErrorBoundary';
import Snackbars from './Snackbars';

export const globalContextPages = [
  '/register-organisation-help',
  '/global-dashboard',
  '/register-organisation',
  '/register-organisation-plan',
  '/global-subcontractors',
  '/access-denied'
];

function setUserInfoInDOM({email, firstName, lastName, fullName, id}) {
  window.ofaEmail = email;
  window.ofaFirstName = firstName;
  window.ofaLastName = lastName;
  window.ofaUserFullName = fullName;
  window.ofaUserId = id;
}

function setOrganisationInfoInDOM(organisation) {
  window.ofaOrganisationRegistrationId = organisation?.registrationNumber;
  window.ofaOrganisationCountry = organisation?.country;
}

function AppLayout() {
  const currentLocale = useSelector(state => state.i18n.locale);
  const user = useSelector(state => state.user);
  const organisation = useSelector(state => state.organisation);
  const location = useLocation();

  React.useEffect(() => {
    moment.locale(currentLocale);
    if (currentLocale === 'fr') {
      mountFAQ();
    }

    return () => {
      unmountFAQ();
    };
  }, [currentLocale]);

  React.useEffect(() => {
    setOrganisationInfoInDOM(organisation);
  }, [organisation?.organisationId]);

  React.useEffect(() => {
    setUserInfoInDOM(user);
  }, [user.email, user.firstName, user.lastName, user.fullName, user.id]);

  const {exportId} = parse(location.search);
  if (exportId) {
    authenticationService.authRedirect(documentService.getExportUrl(exportId))
      .then(authUrl => openOrSaveFile(authUrl));
  }

  const isInGlobalContext = globalContextPages.includes(location.pathname);

  return (
    <ErrorBoundary>
      <div className={`main-template${isInGlobalContext ? ' pt-5' : ''}`}>
        <Snackbars/>
        <Header/>
        <Switch>
          <Route
            exact
            path="/register-organisation-help"
            component={OrganisationRegisterHelpView}
          />
          <Route
            exact
            path="/register-organisation"
            component={OrganisationRegisterView}
          />
          <Route
            exact
            path="/register-organisation-plan"
            component={OrganisationRegisterPlan}
          />
          <Route
            exact
            path="/global-dashboard"
            component={GlobalDashboard}
          />
          <Route
            exact
            path="/global-subcontractors"
            component={GlobalSubcontractors}
          />
          <Route
            exact
            path="/account"
            component={UserSettings}
          />
          <Route component={OrganisationGate}/>
        </Switch>
      </div>
    </ErrorBoundary>
  );
}

export default AppLayout;
